import { KeyboardBackspace } from "@mui/icons-material";
import { Divider, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Messages from "../Messages";
import { useMessageThreads } from "src/context/MessageThreadsProvider";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface ThreadProps {
  page: string;
}

const DesktopMessagingThread = ({ page }: ThreadProps) => {
  const navigate = useNavigate();
  const { currentThread } = useMessageThreads();
  const { i18n, t } = useTranslation();
  const threadName = useMemo(() => currentThread?.name, [currentThread]);
  const language = useMemo(() => i18n.language, [i18n.language]);
  const category = useMemo(() => {
    if (currentThread == null) return "";

    return currentThread.product_category.name.replace(" ", "").toLowerCase();
  }, [currentThread]);
  return (
    <Stack
      height={"100%"}
      width={"100%"}
      maxHeight="78vh"
      sx={{
        boxShadow: "0px 3px 13px 0px rgba(0, 0, 0, 0.05)",
      }}
      borderRadius="10px"
      data-testid="desktop-message-thread"
    >
      <Stack direction="row" gap={1} alignItems="center" padding="16px">
        <IconButton size="small" color="inherit" onClick={() => navigate(-1)}>
          <KeyboardBackspace fontSize="large" />
        </IconButton>
        <Typography fontWeight={700} variant="h6">
          {t(`${page}.${category}.threadHeader`, {
            product: language === "en" ? threadName : threadName?.toLowerCase(),
          })}
        </Typography>
      </Stack>
      <Divider
        sx={{
          backgroundColor: "#E4E7EE",
          mt: 2,
        }}
      />

      <Messages />
    </Stack>
  );
};

export default DesktopMessagingThread;
